import { addEdge, MarkerType, ReactFlowInstance, Edge, Node } from "@xyflow/react";

/**
 * Wires are drawn by the stylesheet, which reads branch semantics off the edge
 * id. This single neutral is only a sensible fallback for anything that renders
 * an edge outside the canvas stylesheet.
 */
const EDGE_STROKE: string = '#4a7183';




/**
 * Generate random string ID for length param
 * @param length
 */
function createRandomString(length: number): string {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i: number = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

/**
 * Process adding a new node and set the type and label
 * @param type
 * @param label
 * @param context
 * @param reactFlowInstance
 */
export function processAddNode(type: string, label: string, context: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let saveNodes = reactFlowInstance.getNodes();
    let defaultStartX = 200;
    let defaultStartY = 400;

    if (saveNodes.length > 0) {
        let lastNode = saveNodes[(saveNodes.length - 1)];
        if (saveNodes.length === 1) {
            lastNode = saveNodes[0];
        }
        if (lastNode.measured !== undefined) {
            defaultStartX = lastNode.position.x + lastNode.measured.width;
            defaultStartY = lastNode.position.y + (lastNode.measured.height * 2);
        } else {
            defaultStartX = lastNode.position.x + 100;
            defaultStartY = lastNode.position.y + 100;
        }

    }

    let id: string = createRandomString(10);
    let nodeName: string = label;
    let isLoopNode: boolean = false;
    if (type === 'workflowNode') {
        nodeName = 'Agent Node';
    }
    if (type === 'workflowLoopNode') {
        isLoopNode = true;
    }

    let newNode: any = {
        id: id,
        data: {
            label: nodeName,
            node_id: id,
            is_loop_node: isLoopNode,
        },
        position: { x: defaultStartX, y: defaultStartY },
        type: type,
    };
    if (type === 'workflowLabelNode') {
        newNode.measured = {
            width: 200,
            height: 100
        };
    }
    if (type === 'workflowIfNode') {
        newNode.data['if_type'] = 'Agent';
    }



    saveNodes.push(newNode);

    context.updateLayoutNodes(saveNodes);
    // setNodes(saveNodes);
    // reactFlowInstance.setNodes(saveNodes);
    // setNodes(saveNodes);
}

const loopableNodes: string[] = [
    'workflowConvertNode',
    'workflowSummarizeNode',
    'workflowHQCreateNode',
    'workflowExtractionNode',
    'workflowHQCreateNode',
    'workflowLoopNode'
];

/**
 * Process Edge connections for various custom Node types
 * @param params
 * @param context
 * @param reactFlowInstance
 * @param setEdges
 */
export function processEdgeConnections(
    params: any,
    context: any,
    reactFlowInstance: ReactFlowInstance
): void {
    const nodes: Node[] = reactFlowInstance.getNodes();
    let targetNode: Node = undefined;
    let sourceNode: Node = undefined;
    for (const node of nodes) {
        if (node.id === params.source) {
            sourceNode = node;
        }
        if (node.id === params.target) {
            targetNode = node;
        }
        if (sourceNode !== undefined && targetNode !== undefined) {
            break;
        }
    }

    if (sourceNode['data']['is_loop_node'] === true && params['sourceHandle'] !== 'loop-condition-loop-exit-source') {
        targetNode['data']['is_loop_node'] = true;
    }

    if (!loopableNodes.includes(targetNode.type) &&
        sourceNode['data']['is_loop_node'] === true &&
        params['sourceHandle'] === 'loop-condition-output-source' ) {
        return;
    }
    // debugger;
    if (sourceNode !== undefined && sourceNode.type !== 'workflowToolNode' ) {
        const edges: Edge[] = reactFlowInstance.getEdges();
        const sourceId: string = sourceNode['id'];
        let isConnected: boolean = false;
        for (const edge of edges) {
            if (edge.target === sourceId) {
                isConnected = true;
            }
        }
        if (!isConnected && sourceId !== 'start_node') {
            return;
        }
    }


    if (sourceNode !== undefined && sourceNode.type !== 'workflowIfNode' && targetNode !== undefined && targetNode.type === 'workflowNode') {
        let edgeId = params.source + '_[->]_' + params.target;

        params.id = edgeId;
        let edge: Edge = {
            id: edgeId,
            ...params,
        }
        const markerEnd =  {
            type: MarkerType.Arrow,
            width: 20,
            height: 20,
            color: EDGE_STROKE,
        };
        edge.markerEnd = markerEnd;
        params.markerEnd = markerEnd;

        const markerStyle = {
            strokeWidth: 2,
            stroke: EDGE_STROKE,
        };
        edge.style = markerStyle;
        params.style = markerStyle
        edge.type = 'deleteButtonEdge'
        params.type = 'deleteButtonEdge'

        if (sourceNode.id === 'start_node') {
            edge.label = 'Start';
            params.label = 'Start';
        }

        edge.reconnectable = true;
        params.reconnectable = true;


        let allEdges: Edge[] = reactFlowInstance.getEdges();
        allEdges.push(edge);
        context.updateLayoutEdges(allEdges);
        return;
    }

    if (sourceNode !== undefined && sourceNode.type !== 'workflowIfNode' && targetNode !== undefined && targetNode.type === 'workflowIfNode') {
        let edgeId = params.source + '_[-if[in]->]_' + params.target;
        params.id = edgeId;
        let edge: Edge = {
            id: edgeId,
            ...params,
        }
        const markerEnd =  {
            type: MarkerType.Arrow,
            width: 20,
            height: 20,
            color: EDGE_STROKE,
        };
        edge.markerEnd = markerEnd;
        edge.label = 'If';
        params.markerEnd = markerEnd;
        params.label = 'If';

        const markerStyle = {
            strokeWidth: 2,
            stroke: EDGE_STROKE,
        };
        edge.style = markerStyle;
        params.style = markerStyle
        edge.type = 'deleteButtonEdge'
        params.type = 'deleteButtonEdge'


        edge.reconnectable = true;
        params.reconnectable = true;
        let allEdges = reactFlowInstance.getEdges();
        allEdges.push(edge);
        context.updateLayoutEdges(allEdges);
        return;
    }

    if (sourceNode !== undefined && sourceNode.type === 'workflowIfNode' && targetNode !== undefined && targetNode.type === 'workflowNode') {
        let isTrue = 'false';
        if (params.sourceHandle === 'true') {
            isTrue = 'true';
        }

        let edgeId = params.source + '_[-if[' + isTrue + ']->]_' + params.target;
        params.id = edgeId;
        let edge: Edge = {
            id: edgeId,
            ...params,
        }
        const markerEnd =  {
            type: MarkerType.Arrow,
            width: 20,
            height: 20,
            color: EDGE_STROKE,
        };
        edge.markerEnd = markerEnd;
        edge.label = (isTrue === 'true' ? 'True' : 'False');
        params.markerEnd = markerEnd;
        params.label = (isTrue === 'true' ? 'True' : 'False');

        const markerStyle = {
            strokeWidth: 2,
            stroke: EDGE_STROKE,
        };
        edge.style = markerStyle;
        params.style = markerStyle
        edge.type = 'deleteButtonEdge';
        params.type = 'deleteButtonEdge';


        edge.reconnectable = true;
        params.reconnectable = true;

        let allEdges = reactFlowInstance.getEdges();
        let canAdd: boolean = true;
        for (let allEdge of allEdges) {
            if (allEdge.id === edgeId) {
                canAdd = false;
            }
        }
        if (canAdd) {
            allEdges.push(edge);
            context.updateLayoutEdges(allEdges);
        }

        return;

    }

    let id = params.source + '_[->]_' + params.target;
    if (targetNode !== undefined && targetNode.type === 'workflowScraperNode') {
        id = params.source + '_[scraper->]_' + params.target;
    }
    params.id = id;
    let edge: Edge = {
        id,
        ...params
    }
    const markerEnd = {
        type: MarkerType.Arrow,
        width: 20,
        height: 20,
        color: EDGE_STROKE,
    }

    edge.markerEnd = markerEnd;
    params.markerEnd = markerEnd;

    const markerStyle = {
        strokeWidth: 2,
        stroke: EDGE_STROKE,
    };
    edge.style = markerStyle;
    params.style = markerStyle;

    // edge.is_loop_edge = targetNode['data']['is_loop_node'];
    // params.is_loop_edge = targetNode['data']['is_loop_node'];

    if (sourceNode.id === 'start_node') {
        edge.label = 'Start';
        params.label = 'Start';
    }
    edge.type = 'deleteButtonEdge'
    params.type = 'deleteButtonEdge'

    let allEdges = reactFlowInstance.getEdges();
    allEdges.push(edge);
    context.updateLayoutEdges(allEdges);

    return;
}




export type WorkflowNodeGroup =
    'intelligence' | 'acquisition' | 'data' | 'transform' | 'flow' | 'note';

export type WorkflowNodeItem = {
    type: string,
    title: string,
    label: string,
    slug: string,
    group: WorkflowNodeGroup
};

/**
 * The add-node palette.
 *
 * `slug` is the class the node renders with on the canvas; it is what the
 * stylesheet keys its accent and glyph off, so the palette entry and the placed
 * node always look like the same thing. `group` is the family it belongs to.
 */
export const workflowNodeItems: WorkflowNodeItem[] = [
    // Intelligence
    { type: 'workflowNode',            title: 'Agent',          label: 'Untitled Agent Node',            slug: 'agent',          group: 'intelligence' },
    { type: 'workflowSummarizeNode',   title: 'Summarise',      label: 'Untitled Summarize Node',        slug: 'summarize',      group: 'intelligence' },
    { type: 'workflowExtractionNode',  title: 'Extract',        label: 'Untitled Extraction Node',       slug: 'extraction',     group: 'intelligence' },

    // Acquisition
    { type: 'workflowScraperNode',     title: 'Web Scraper',    label: 'Untitled Web Scraper Node',      slug: 'scraper',        group: 'acquisition' },
    { type: 'workflowSitemapNode',     title: 'Sitemap',        label: 'Untitled Sitemap Parse Node',    slug: 'sitemap',        group: 'acquisition' },
    { type: 'workflowHTTPNode',        title: 'HTTP Request',   label: 'Untitled HTTP Node',             slug: 'http',           group: 'acquisition' },

    // Data
    { type: 'workflowHQDataFetchNode', title: 'HQ Fetch',       label: 'Untitled HQ Data Fetch Node',    slug: 'hq-data-fetch',  group: 'data' },
    { type: 'workflowHQCreateNode',    title: 'HQ Create',      label: 'Untitled HQ Data Create Node',   slug: 'hq-data-create', group: 'data' },
    { type: 'workflowHQUploadNode',    title: 'HQ Update',      label: 'Untitled HQ Data Upload Node',   slug: 'hq-data-upload', group: 'data' },
    { type: 'workflowSampleDataNode',  title: 'Sample Data',    label: 'Untitled Sample Data Node',      slug: 'sample-data',    group: 'data' },
    { type: 'workflowDataResetNode',   title: 'Data Reset',     label: 'Untitled Date Reset Node',       slug: 'data-reset',     group: 'data' },
    { type: 'workflowUiUpdateNode',    title: 'UI Update',      label: 'Untitled UI Update Node',        slug: 'ui-update',      group: 'data' },

    // Transform
    { type: 'workflowConvertNode',     title: 'Convert',        label: 'Untitled Convert Node',          slug: 'convert',        group: 'transform' },
    { type: 'workflowMoveNode',        title: 'Move',           label: 'Untitled Move Node',             slug: 'moving',         group: 'transform' },
    { type: 'workflowFilterNode',      title: 'Filter',         label: 'Untitled Filter Node',           slug: 'filter',         group: 'transform' },
    { type: 'workflowSortNode',        title: 'Sort',           label: 'Untitled Sort Node',             slug: 'sort',           group: 'transform' },
    { type: 'workflowInjectionNode',   title: 'Inject',         label: 'Untitled Injection Node',        slug: 'injection',      group: 'transform' },

    // Flow
    { type: 'workflowIfNode',          title: 'If',             label: 'Untitled If Node',               slug: 'if-condition',   group: 'flow' },
    { type: 'workflowSwitchNode',      title: 'Switch',         label: 'Untitled Switch Node',           slug: 'switch',         group: 'flow' },
    { type: 'workflowLoopNode',        title: 'Loop',           label: 'Untitled Loop Node',             slug: 'loop-condition', group: 'flow' },
    { type: 'workflowMergeNode',       title: 'Merge',          label: 'Untitled Merge Node',            slug: 'merge',          group: 'flow' },
    { type: 'workflowParallelNode',    title: 'Parallel',       label: 'Untitled Parallel Node',         slug: 'parallel',       group: 'flow' },
    { type: 'workflowHumanNode',       title: 'Human Review',   label: 'Untitled Human Node',            slug: 'human',          group: 'flow' },

    // Annotation
    { type: 'workflowLabelNode',       title: 'Note',           label: 'Untitled Label Node',            slug: 'label-node',     group: 'note' },
];

export const workflowNodeGroupLabels: Record<WorkflowNodeGroup, string> = {
    intelligence: 'Intelligence',
    acquisition:  'Acquisition',
    data:         'Data',
    transform:    'Transform',
    flow:         'Flow',
    note:         'Annotation',
};

/**
 * Family accents, mirrored from the --wf-c-* tokens in styles/_tokens.scss.
 *
 * The stylesheet is the source of truth for anything rendered as DOM. These
 * exist only for the minimap, which paints node colours as SVG `fill`
 * attributes — and an attribute cannot resolve a CSS custom property. Keep the
 * two in step when a family accent changes.
 */
type WorkflowAccentSet = Record<WorkflowNodeGroup | 'terminal' | 'halt', string>;

export const workflowAccents: { light: WorkflowAccentSet, dark: WorkflowAccentSet } = {
    light: {
        intelligence: '#6d3ff2',
        acquisition:  '#0b7fc4',
        data:         '#0d8f80',
        transform:    '#c62f9e',
        flow:         '#2563eb',
        note:         '#a67c00',
        terminal:     '#15803d',
        halt:         '#dc2626',
    },
    dark: {
        intelligence: '#b69bff',
        acquisition:  '#4cc4f5',
        data:         '#3ed6bd',
        transform:    '#f57ecb',
        flow:         '#6f9cf7',
        note:         '#ffd600',
        terminal:     '#4ade80',
        halt:         '#fb6f6f',
    },
};

const workflowTypeGroups: Record<string, WorkflowNodeGroup> = workflowNodeItems.reduce(
    (acc: Record<string, WorkflowNodeGroup>, item: WorkflowNodeItem) => {
        acc[item.type] = item.group;
        return acc;
    },
    {}
);

/** Accent for a node type in the given palette mode, used by the minimap. */
export function accentForNodeType(type: string, mode: 'light' | 'dark' = 'dark'): string {
    const set: WorkflowAccentSet = workflowAccents[mode] ?? workflowAccents.dark;
    if (type === 'workflowStartNode') return set.terminal;
    if (type === 'workflowEndNode') return set.halt;
    if (type === 'workflowToolNode') return set.intelligence;
    return set[workflowTypeGroups[type]] ?? set.flow;
}
